<script>

export default {

    methods: {
        $_phoneAddDashes(event) {
            let phoneNumber = event.target.value;
            const inputField = event.target;
            const skipKeys = [
                16,  // Shift
                17,  // Control
                18,  // Alt
                20,  // Caps Lock
                144, // Num Lock
                13,  // Enter
                9,   // Tab
                37,  // Left Arrow
                38,  // Up Arrow
                39,  // Right Arrow
                40   // Down Arrow

            ];

            if (skipKeys.includes(event.which)) {
                return;
            }

            // Save cursor location (or selection area if applicable)
            let cursorStart = inputField.selectionStart;
            let cursorEnd = inputField.selectionEnd;

            // Normalize Phone Number
            phoneNumber = phoneNumber.trim();
            phoneNumber = phoneNumber.replace(/[^0-9]/g, '')

            // Remove leading country code
            if (phoneNumber.length == 11 && phoneNumber[0] == '1') {
                phoneNumber = phoneNumber.slice(1);

                if (cursorEnd == 1) {
                    cursorStart = 0;
                    cursorEnd = 0;
                }
            }

            if (phoneNumber.length >= 3) {
                phoneNumber = phoneNumber.slice(0,3) + '-' + phoneNumber.slice(3)

                // Make sure to update cursor position
                if (cursorEnd == 3) {
                    cursorStart++;
                    cursorEnd++;
                }
            }
            if (phoneNumber.length >= 7) {
                phoneNumber = phoneNumber.slice(0,7) + '-' + phoneNumber.slice(7)

                // Make sure to update cursor position
                if (cursorEnd == 7) {
                    cursorStart++;
                    cursorEnd++;
                }
            }

            inputField.value = phoneNumber;

            // restore cursor position
            inputField.setSelectionRange(cursorStart, cursorEnd);
        },
    }
}
</script>
